import SiteUserTable from "../../Tables/SiteUser/SiteUserTable";
import { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import Modal from "../../Components/Modal/Modal";
import AddOrEditSiteUserForm from "../../Forms/AddOrEditSiteUser";

const SiteUserManager = () => {
  const [tableRefreshFlag, setTableRefreshFlag] = useState(false);
  const [isAddOpen, setIsAddOpen] = useState(false);

  return (
    <div className="w-full">
      {isAddOpen ? (
        <Modal
          UI={
            <AddOrEditSiteUserForm
              onClose={() => {
                setIsAddOpen(false);
                setTableRefreshFlag(true);
              }}
            />
          }
          onClose={() => setIsAddOpen(false)}
          modalBoxClassName="!min-w-[340px]"
        />
      ) : null}
      <div className="w-fit flex items-center mb-2 mt-5 mr-auto ml-5 gap-3">
        <div
          className="bg-sky-600 rounded-full flex justify-center items-center w-11 h-11 cursor-pointer"
          onClick={() => setIsAddOpen(true)}
        >
          <AddIcon className="text-white" />
        </div>
      </div>
      <div className="mx-auto">
        <SiteUserTable
          setTableRefreshFlag={setTableRefreshFlag}
          tableRefreshFlag={tableRefreshFlag}
        />
      </div>
    </div>
  );
};

export default SiteUserManager;
